/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recent_ResultsInputs */

const th_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผลการแข่งขันล่าสุด`)
};

const en_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent results`)
};

const ja_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近の結果`)
};

const zh_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近期结果`)
};

const es_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados recientes`)
};

const pt_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados recentes`)
};

const id_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasil terbaru`)
};

const fr_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résultats récents`)
};

const tl_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga kamakailang resulta`)
};

const vi_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết quả gần đây`)
};

const ko_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최근 결과`)
};

const de_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Ergebnisse`)
};

const ru_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние результаты`)
};

const tr_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son sonuçlar`)
};

const it_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati recenti`)
};

const pl_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnie wyniki`)
};

const uk_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні результати`)
};

const hi_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाल के परिणाम`)
};

const ar_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحدث النتائج`)
};

const ms_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keputusan terkini`)
};

const bn_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাম্প্রতিক ফল`)
};

const zh_tw2_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近期結果`)
};

const zh_hk2_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近期結果`)
};

const ur_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حالیہ نتائج`)
};

const fa_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نتایج تازه`)
};

const sw_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matokeo ya karibuni`)
};

const nl_recent_results = /** @type {(inputs: Recent_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recente uitslagen`)
};

/**
* | output |
* | --- |
* | "Recent results" |
*
* @param {Recent_ResultsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const recent_results = /** @type {((inputs?: Recent_ResultsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recent_ResultsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_recent_results(inputs)
	if (locale === "ja") return ja_recent_results(inputs)
	if (locale === "zh") return zh_recent_results(inputs)
	if (locale === "es") return es_recent_results(inputs)
	if (locale === "pt") return pt_recent_results(inputs)
	if (locale === "id") return id_recent_results(inputs)
	if (locale === "fr") return fr_recent_results(inputs)
	if (locale === "tl") return tl_recent_results(inputs)
	if (locale === "vi") return vi_recent_results(inputs)
	if (locale === "ko") return ko_recent_results(inputs)
	if (locale === "de") return de_recent_results(inputs)
	if (locale === "ru") return ru_recent_results(inputs)
	if (locale === "tr") return tr_recent_results(inputs)
	if (locale === "it") return it_recent_results(inputs)
	if (locale === "pl") return pl_recent_results(inputs)
	if (locale === "uk") return uk_recent_results(inputs)
	if (locale === "hi") return hi_recent_results(inputs)
	if (locale === "ar") return ar_recent_results(inputs)
	if (locale === "ms") return ms_recent_results(inputs)
	if (locale === "bn") return bn_recent_results(inputs)
	if (locale === "zh-TW") return zh_tw2_recent_results(inputs)
	if (locale === "zh-HK") return zh_hk2_recent_results(inputs)
	if (locale === "ur") return ur_recent_results(inputs)
	if (locale === "fa") return fa_recent_results(inputs)
	if (locale === "sw") return sw_recent_results(inputs)
	if (locale === "nl") return nl_recent_results(inputs)
	return en_recent_results(inputs)
});